import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Inject,
  PLATFORM_ID,
} from "@angular/core";
import { Router } from "@angular/router";
import { isPlatformBrowser } from "@angular/common";
import { environment } from "../../../../environments/environment";
import { TranslateService } from "@ngx-translate/core";
import {
  MarkerClusterer,
  MarkerClustererOptions,
} from "@googlemaps/markerclusterer";

declare var google;

// declare var markerClusterer;

@Component({
  selector: "app-map",
  templateUrl: "./map.component.html",
  styleUrls: ["./map.component.scss"],
})
export class MapComponent implements OnInit, OnChanges {
  @Input() data: any[];
  @Input() lang: string;
  areas = [];
  icon01;
  icon02;
  icon03;
  icon04;
  icon05;
  icon06;
  icon07;
  icon08;
  icon09;
  icon10;
  cluster: MarkerClusterer | null = null; // Initialize and type this.cluster

  spot_items;
  showMultiAreas = false;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      if (sessionStorage.getItem("show-welcome") === "false") {
        getPosition(true, this.translate);
      }
      sessionStorage.removeItem("survey");
    }
  }

  ngOnChanges() {
    if (isPlatformBrowser(this.platformId)) {
      this.icon01 = new Image();
      this.icon02 = new Image();
      this.icon03 = new Image();
      this.icon04 = new Image();
      this.icon05 = new Image();
      this.icon06 = new Image();
      this.icon07 = new Image();
      this.icon08 = new Image();
      this.icon09 = new Image();
      this.icon10 = new Image();
      this.icon01.src = urlIcon + "icon_quiet_1.png";
      this.icon02.src = urlIcon + "icon_quiet_2.png";
      this.icon03.src = urlIcon + "icon_quiet_3.png";
      this.icon04.src = urlIcon + "icon_quiet_4.png";
      this.icon05.src = urlIcon + "icon_quiet_5.png";
      this.icon06.src = urlIcon + "icon_quiet_6.png";
      this.icon07.src = urlIcon + "icon_quiet_7.png";
      this.icon08.src = urlIcon + "icon_quiet_8.png";
      this.icon09.src = urlIcon + "icon_quiet_9.png";
      this.icon10.src = urlIcon + "icon_quiet_10.png";
      this.initMap();
      this.translate.use(this.lang);
      const that = this;
      if (
        sessionStorage.getItem("survey") &&
        sessionStorage.getItem("survey") !== "[]"
      ) {
        const survey = sessionStorage.getItem("survey");
        this.data = JSON.parse(survey);
      }
      this.icon10.onload = function () {
        that.processAreas(that.data, that.translate);
      };
    }
  }

  getCurrentPosition() {
    if (isPlatformBrowser(this.platformId)) {
      getPosition(true, this.translate);
    }
  }

  youAreHere() {
    if (isPlatformBrowser(this.platformId)) {
      google.maps.event.trigger(myMarker, "click");
      map.setCenter(currentPosition);
    }
  }

  searchLocation(element) {
    if (isPlatformBrowser(this.platformId)) {
      searchMap(element);
    }
  }

  filterArea(result) {
    this.processAreas(result, this.translate);
  }

  async initMap() {
    if (isPlatformBrowser(this.platformId)) {
      map = new google.maps.Map(document.getElementById("map"), {
        center: defaultCenter,
        gestureHandling: "greedy",
        disableDefaultUI: true,
        minZoom: 2,
        maxZoom: 18,
        zoom: 2,
      });
      google.maps.event.addListener(map, "zoom_changed", () => {
        sessionStorage.setItem("map-zoom-level", map.getZoom());
      });
    }
  }

  createMarker(background, number) {
    let canvas, context;
    canvas = document.createElement("canvas");
    canvas.width = 39;
    canvas.height = 55;
    context = canvas.getContext("2d");
    context.font = "500 18px Helvetica Neue";
    context.fillStyle = "#fff";
    context.drawImage(background, 0, 0);
    context.fillText(number, 15, 25);
    return canvas.toDataURL();
  }

  processAreas(areas, varTranslate) {
    const self = this;
    if (isPlatformBrowser(this.platformId)) {
      let positions, allPosition;
      // sessionZoom = sessionStorage.getItem('map-zoom-level');
      allPosition = [];
      if (wantLocation === undefined) {
        allPosition[0] = {
          position: new google.maps.LatLng(
            locationDefault.lat,
            locationDefault.lng
          ),
        };
      } else {
        allPosition[0] = {
          position: new google.maps.LatLng(wantLocation.lat, wantLocation.lng),
        };
      }
      positions = [];
      areas.forEach((area) => {
        let group = {
          address: area.address,
          areas: area.areas,
          position: new google.maps.LatLng(
            area.areas[0].latitude,
            area.areas[0].longitude
          ),
        };
        positions.push(group);
      });
      for (let i = 0; i < positions.length; i++) {
        let item = positions[i];
        allPosition[i + 1] = {
          position: item.position,
        };
      }
      singleWindow = new google.maps.InfoWindow();
      let marker;
      markers = positions.map(function (feature, index) {
        let area = feature.areas[0];
        let position = new google.maps.LatLng(area.latitude, area.longitude);
        let attributes = self.attributesForNoiseLevel(area.noise_eq);
        let total = feature.areas.length;

        marker = new google.maps.Marker({
          position: position,
          icon: self.createMarker(attributes.icon, total),
          zIndex: index,
        });
        let textNames,
          textName,
          textIs,
          textStatus,
          textTimes,
          textMoreDetail,
          newTime,
          weekday,
          time,
          date,
          ext;
        varTranslate.get(area.name.substr(0, 4)).subscribe((res: string) => {
          textName = res;
        });
        varTranslate.get("is").subscribe((res: string) => {
          textIs = res;
        });
        varTranslate
          .get(
            (
              area.noise_status.charAt(0).toUpperCase() +
              area.noise_status.slice(1)
            ).trim()
          )
          .subscribe((res: string) => {
            textStatus = res;
          });
        varTranslate.get("More Details").subscribe((res: string) => {
          textMoreDetail = res;
        });

        setTimeout(() => {
          textNames = textName + " " + area.name.substr(5) + textIs;
          newTime = new Date(area.time * 1000);
          const optionsWeek = {
            timeZone: area.timezone,
            weekday: "long",
          };
          weekday = new Intl.DateTimeFormat(
            sessionStorage.getItem("language"),
            optionsWeek
          ).format(newTime);
          const optionsDate = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            timeZone: area.timezone,
          };
          newTime = new Intl.DateTimeFormat("en", optionsDate).format(newTime);
          time = newTime.split(", ")[1];
          date = newTime.split(", ")[0];
          textTimes = weekday + " " + time + " " + date;
          textMoreDetail = textMoreDetail;
          ext = area.audio
            .split(".")
            [area.audio.split(".").length - 1].toLowerCase();
          if (ext !== "ogg" && ext !== "wav") {
            ext = "mpeg";
          }
        }, 300);

        google.maps.event.addListener(
          marker,
          "click",
          ((mark) => {
            return () => {
              if (total > 1) {
                self.showMultiAreas = true;
                self.spot_items = feature.areas;
                return;
              } else {
                singleWindow.setContent(
                  `<div id="info-location">
                  <span id="close" class="close-detail"></span>
                  <div class="ctent-detail">
                    <p class="tit-name">
                      ${textNames}
                      <span class="${attributes.color}">${textStatus}</span>
                    </p>
                    <div class="text-pop">
                      <div class="img-detail">
                        <img src="${area.photo}" onError="src='assets/images/no-image-big.png'" alt="Area">
                      </div>
                      <audio id="detail-audio">
                        <source src="${area.audio}" type="audio/${ext}"> {{ 'Your browser does not support the audio element.' | translate }}
                      </audio>
                      <div id="virtual" class="media">
                        <div id="media-fill"></div>
                        <div id="media-thumb"></div>
                        <span id="media-control" class="media-play"></span>
                      </div>
                      <div class="time">
                        ${textTimes}
                      </div>
                      <div class="address-detail">${area.address}</div>
                      <span class="more-detail more-detail-btn">${textMoreDetail}</span>
                    </div>
                  </div>
                </div>`
                );
                const windowReady = () => {
                  const closeBtn =
                    document.getElementsByClassName("gm-ui-hover-effect")[0];
                  if (closeBtn) {
                    closeBtn.remove();
                  }
                  document
                    .getElementsByClassName("more-detail-btn")[0]
                    .addEventListener("click", () => {
                      sessionStorage.setItem(
                        "current",
                        '{ "center": { "lat": "' +
                          map.getCenter().lat() +
                          '", "lng": "' +
                          map.getCenter().lng() +
                          '" }, "zoom": ' +
                          map.getZoom() +
                          " }"
                      );
                      sessionStorage.setItem("survey", JSON.stringify(areas));
                      self.router.navigate(["/area-detail/" + area.id]);
                    });
                  self.handleAudio(feature, total > 1);
                };
                google.maps.event.addListener(
                  singleWindow,
                  "domready",
                  windowReady
                );
              }
              singleWindow.open(map, mark);
              mark.setZIndex(mark.getZIndex() - 2);
              map.panTo(position);
              map.panBy(0, -290);
            };
          })(marker)
        );
        return marker;
      });

      if (this.cluster) {
        /** 
        markerCluster = this.cluster;
        markerCluster.clearMarkers();
        this.cluster = undefined;
        markerCluster = undefined;
        */

        this.cluster.clearMarkers();
        this.cluster = null;
      }

      const clusterStyles = [
        {
          textColor: "#fff",
          textSize: 14,
          url: "assets/images/icon_cluster_10.png",
          height: 57,
          width: 57,
        },
        {
          textColor: "#fff",
          textSize: 14,
          url: "assets/images/icon_cluster_3.png",
          height: 57,
          width: 57,
        },
        {
          textColor: "#fff",
          textSize: 14,
          url: "assets/images/icon_cluster_6.png",
          height: 57,
          width: 57,
        },
        {
          textColor: "#fff",
          textSize: 14,
          url: "assets/images/icon_cluster_8.png",
          height: 57,
          width: 57,
        },
        {
          textColor: "#fff",
          textSize: 14,
          url: "assets/images/icon_cluster_9.png",
          height: 57,
          width: 57,
        },
      ];

      /*
      markerCluster = new MarkerClusterer(map, markers, {
        styles: clusterStyles,
        maxZoom: 8,
        minimumClusterSize: 1,
      });
      */

      //const markerClusterer = new MarkerClusterer({
      // Assign the new MarkerClusterer instance to this.cluster
      this.cluster = new MarkerClusterer({
        map: map,
        markers: markers,
        //styles: clusterStyles,
        //maxZoom: 8,
        //minimumClusterSize: 1,
      });

      /** 
      markerCluster.setCalculator(function (mark) {
        let index, count;
        index = 0;
        count = mark.length;
        if (count <= 50) {
          index = 1;
        } else if (count > 50 && count <= 100) {
          index = 2;
        } else if (count > 100 && count <= 200) {
          index = 3;
        } else if (count > 200 && count <= 1000) {
          index = 4;
        } else {
          index = 5;
        }
        if (count > 1000) {
          return {
            text: "1000+",
            index: index,
          };
        } else {
          return {
            text: count,
            index: index,
          };
        }
      });
      this.cluster = markerCluster;
      */

      const bounds = new google.maps.LatLngBounds();
      allPosition.forEach(function (feature) {
        bounds.extend(feature.position);
      });
      if (sessionStorage.getItem("current")) {
        const lc = JSON.parse(sessionStorage.getItem("current"));
        map.setCenter(new google.maps.LatLng(lc.center.lat, lc.center.lng));
        map.setZoom(lc.zoom);
        sessionStorage.removeItem("current");
      }
    }
  }

  handleAudio(feature, isMulti) {
    if (isMulti) {
      this.showMultiAreas = true;
      this.spot_items = feature.areas;
      return;
    }
    if (infoWindow) {
      infoWindow.close();
    }
    let close_obj = document.getElementById("close");
    if (close_obj && singleWindow) {
      close_obj.addEventListener("click", () => {
        singleWindow.close();
      });
    }
    const old_control = document.getElementById("media-control");
    const control = <HTMLElement>old_control.cloneNode(true);
    old_control.parentNode.replaceChild(control, old_control);
    const media = <HTMLMediaElement>document.getElementById("detail-audio");
    const thumb = document.getElementById("media-thumb");
    media.addEventListener("canplay", () => {
      control.addEventListener("click", onPlayMedia);
      media.addEventListener("timeupdate", timeUpdate);
      function timeUpdate() {
        control.style.left =
          Math.round((media.currentTime / media.duration) * 100) + "%";
        thumb.style.width =
          Math.round((media.currentTime / media.duration) * 100) + "%";
        if (control.style.left === "100%") {
          control.classList.remove("media-pause");
          control.classList.add("media-play");
          control.style.left = "0";
          thumb.style.width = "0";
        }
      }
    });
    document
      .getElementById("media-fill")
      .addEventListener("click", changeTimeline);
    const audio = media;
    function onPlayMedia() {
      const playpause = document.getElementById("media-control");
      if (audio.paused) {
        audio.play();
        playpause.classList.remove("media-play");
        playpause.classList.add("media-pause");
      } else {
        audio.pause();
        playpause.classList.remove("media-pause");
        playpause.classList.add("media-play");
      }
    }
    function changeTimeline(event) {
      const timeLine = document.getElementById("media-fill");
      const posTimeLine = timeLine.getBoundingClientRect().left;
      const control = document.getElementById("media-control");
      const thumb = document.getElementById("media-thumb");
      audio.currentTime =
        audio.duration * ((event.clientX - posTimeLine) / timeLine.offsetWidth);
      control.style.left = (audio.currentTime / audio.duration) * 100 + "%";
      thumb.style.width = (audio.currentTime / audio.duration) * 100 + "%";
    }
  }

  zoomIn() {
    map.setZoom(map.getZoom() + 1);
  }

  zoomOut() {
    map.setZoom(map.getZoom() - 1);
  }

  closeMultiAreas() {
    this.showMultiAreas = false;
  }

  savePage(id) {
    sessionStorage.setItem(
      "current",
      '{ "center": { "lat": "' +
        map.getCenter().lat() +
        '", "lng": "' +
        map.getCenter().lng() +
        '" }, "zoom": ' +
        map.getZoom() +
        " }"
    );
    sessionStorage.setItem("survey", JSON.stringify(this.data));
    this.router.navigate(["/area-detail/" + id]);
  }

  attributesForNoiseLevel(level) {
    let color, icon;
    if (level <= 35) {
      color = "color-legend01";
      icon = this.icon01;
    } else if (level > 35 && level <= 40) {
      color = "color-legend02";
      icon = this.icon02;
    } else if (level > 40 && level <= 45) {
      color = "color-legend03";
      icon = this.icon03;
    } else if (level > 45 && level <= 50) {
      color = "color-legend04";
      icon = this.icon04;
    } else if (level > 50 && level <= 55) {
      color = "color-legend05";
      icon = this.icon05;
    } else if (level > 55 && level <= 60) {
      color = "color-legend06";
      icon = this.icon06;
    } else if (level > 60 && level <= 65) {
      color = "color-legend07";
      icon = this.icon07;
    } else if (level > 65 && level <= 70) {
      color = "color-legend08";
      icon = this.icon08;
    } else if (level > 70 && level <= 75) {
      color = "color-legend09";
      icon = this.icon09;
    } else {
      color = "color-legend10";
      icon = this.icon10;
    }
    return {
      color: color,
      icon: icon,
    };
  }
}

//let map, markers, infoWindow, singleWindow, markerCluster;

// Remove global markerCluster, others are still used by global functions
let map, markers, infoWindow, singleWindow;

const urlIcon = "assets/images/";
let currentPosition;
const locationDefault = environment.locationDefault;
const defaultCenter = { lat: 0, lng: 0 };

let myTemp = [];
let myMarker;
function getPosition(value, varTranslate) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        currentPosition = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        myTemp.forEach(function (feature, index) {
          myTemp[index].setMap(null);
        });
        myTemp = [];
        myMarker = new google.maps.Marker({
          position: currentPosition,
          icon: urlIcon + "user-location-ic.png",
          zIndex: 1000,
        });
        myTemp.push(myMarker);
        myMarker.setMap(map);
        infoWindow = new google.maps.InfoWindow();
        const geocoder = new google.maps.Geocoder();
        let txtAddress;
        let textHere;
        varTranslate.get("You are here!").subscribe((res: string) => {
          textHere = res;
        });
        geocoder.geocode(
          { location: currentPosition },
          function (results, status) {
            if (status.toString() === "OK") {
              if (results[0]) {
                txtAddress = results[0].formatted_address;
                infoWindow.setContent(
                  `<div id="info-location">
                <div class="text-of-my">
                  <p class="tit-here">${textHere}</p>
                  <p class="txt-address-here">${txtAddress}</p>
                </div>
              </div>`
                );
              } else {
                console.log("No results found");
              }
            } else {
              console.log("Geocoder failed due to: " + status);
            }
          }
        );
        myMarker.addListener("click", () => {
          if (singleWindow) {
            singleWindow.close();
          }
          infoWindow.open(map, myMarker);
        });
        google.maps.event.addListener(map, "click", () => {
          if (infoWindow) {
            infoWindow.close();
          }
          if (singleWindow) {
            singleWindow.close();
          }
        });
        saveLocation(currentPosition);
      },
      function () {
        handleLocationError(true, infoWindow, locationDefault);
      }
    );
  } else {
    handleLocationError(false, infoWindow, locationDefault);
  }
}

function handleLocationError(browserHasGeolocation, infowindow, position) {
  infowindow.setPosition(position);
  infowindow.setContent(
    browserHasGeolocation
      ? "Error: The Geolocation service failed."
      : "Error: Your browser doesn't support geolocation."
  );
  infowindow.open(map);
}

let wantLocation;
function saveLocation(location) {
  wantLocation = location;
}

function searchMap(element) {
  const input = <HTMLInputElement>element;
  const searchBox = new google.maps.places.SearchBox(input);
  map.addListener("bounds_changed", function () {
    searchBox.setBounds(map.getBounds());
  });
  let smarker = [];
  searchBox.addListener("places_changed", function () {
    const places = searchBox.getPlaces();
    if (places.length === 0) {
      return;
    }
    smarker.forEach(function (markerResult) {
      markerResult.setMap(null);
    });
    smarker = [];
    const bounds = new google.maps.LatLngBounds();
    let searchLocation;
    places.forEach(function (place) {
      if (!place.geometry) {
        console.log("Returned place contains no geometry");
        return;
      }
      smarker.push(
        new google.maps.Marker({
          map: map,
          title: place.name,
          position: place.geometry.location,
          zIndex: 9999999999,
        })
      );
      if (place.geometry.viewport) {
        bounds.union(place.geometry.viewport);
      } else {
        bounds.extend(place.geometry.location);
      }
      searchLocation = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      saveLocation(searchLocation);
    });
    map.fitBounds(bounds);
    map.setZoom(map.getZoom());
  });
}
